const Upload = {
  props: [
    {
      name: 'disabled',
      default: '',
      type: 'boolean',
      desc: '禁用'
    },
    {
      name: 'action',
      default: '',
      type: 'string',
      desc: '上传地址'
    },
    {
      name: 'value',
      default: '',
      type: 'FileData[]',
      desc: '文件数据， v-model'
    },
    {
      name: 'resp',
      default: '',
      type: '(response: any) => FileData',
      desc: '上传结果转换，要求必须是FileData类型'
    },
    {
      name: 'request',
      default: '',
      type: 'Request',
      desc: '自定义上传，用用于实现oss上传等'
    },
    {
      name: 'accept',
      default: 'image/jpeg,image/jpg,image/png,.pdf,.xlsx,.docx',
      type: 'string',
      desc: '限制上传文件格式'
    },
    {
      name: 'limit',
      default: '',
      type: 'number',
      desc: '限制上传文件个数'
    },
    {
      name: 'maxSize',
      default: '',
      type: 'string',
      desc: '限制上传文件大小，例如 100K, 10M'
    },
    {
      name: 'beforeUpload',
      default: '',
      type: '(file: any, fileList: any[]) => boolean | Promise<any>',
      desc: '上传前钩子函数'
    },
    {
      name: 'inline',
      default: '',
      type: 'boolean',
      desc: '文件列表行内展示，仅在type=list有效'
    }
  ]
}

export default [
  {
    name: 'Upload API',
    content: Upload
  }
]
